module.exports = __webpack_public_path__ + "img/copper.fd2dbfd2.png";